export default __webpack_public_path__ + "static/media/tailwind.254c4865.svg";